import React from 'react';
import { Link } from 'react-router-dom';
import { Provider } from 'models';
import DefaultProfileImage from 'assets/icons/Profile.svg';
import { Colors } from 'library';
import useGoToProfile from './actions/goToProfile';

const ProviderCardProfileImage = ({
    provider,
    mobile = false,
    onGoToProfileClick,
    jobId,
}: {
    provider: Provider;
    mobile?: boolean;
    onGoToProfileClick?: () => void;
    jobId?: number;
}) => {
    const { getProfilePath, onGoToProfileLinkClicked } = useGoToProfile();

    return (
        <Link
            to={getProfilePath(provider, jobId)}
            onClick={() => onGoToProfileLinkClicked(provider, 'Provider Card Click', onGoToProfileClick)}
        >
            {!!provider.profile_image?.image ? (
                <div
                    style={{
                        width: mobile ? 100 : '100%',
                        height: mobile ? 120 : 330,
                        overflow: 'hidden',
                        backgroundColor: Colors.white,
                        backgroundImage: `url(${provider.profile_image?.image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: mobile ? 8 : 0,
                        borderTopRightRadius: mobile ? 8 : 18,
                        borderTopLeftRadius: mobile ? 8 : 18,
                    }}
                />
            ) : (
                <DefaultProfileImage
                    style={{
                        width: mobile ? 100 : '100%',
                        height: mobile ? 120 : 330,
                        borderRadius: mobile ? 8 : 0,
                        borderTopRightRadius: mobile ? 8 : 18,
                        borderTopLeftRadius: mobile ? 8 : 18,
                    }}
                />
            )}
        </Link>
    );
};
export default ProviderCardProfileImage;
